













import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name      : "StadiumTags",
  props     : {
    id          : { type: String, required: true },
    button      : { type: Boolean, default: true },
    stadium_tags: { type: Array, required: true },
  },
  data() {
    return {
      tags    : [],
      options : [
        { label: "-", value: "0" }
      ]
    }
  },
  methods: {
    init() {
      this.get_tags()
    },
    async get_tags() {
      const params = { type_id: 1, page: 1 }
      const res    = await this.$store.dispatch("stadium/getTags", params);
      if (res.Code == 200) {
        this.options = []
        for (const item of res.Data) {
          this.options.push({ label: item.name, value: String(item.id) })
        }
      }
    },
    submit() {
      const params = { estimate_id: this.id, stadium_tags: this.tags.join(",") }
      this.$emit("update:stadium_tags", this.tags)
      this.$emit("save", params)
    }
  },
  watch: {
    stadium_tags(tags: []) {
      if (tags.length > 0) {
        this.tags = tags
      }
    }
  }
})
